import { Pipe, PipeTransform } from '@angular/core';
import { Indication } from '@zero/home/domain';
import { IndicationTab } from './indication-tab.model';

@Pipe({
  name: 'indicationTab',
  standalone: true,
})
export class IndicationTabPipe implements PipeTransform {
  public transform = (indications: Indication[], tab: IndicationTab): Indication[] =>
    tab.types.length
      ? indications.filter(({ instrumentType }) => tab.types.includes(instrumentType))
      : indications.filter(({ isOverviewInstrument }) => isOverviewInstrument).sort(({ order: a }, { order: b }) => a - b);
}
